/**
 * API Client
 *
 * Handles base URL and authentication headers for all API requests.
 * Uses VITE_API_URL in production, relative URLs in development.
 */

import { getAuthToken } from '../hooks/useAuth';
import { resolveApiUrl } from './api-base';

/**
 * Make an authenticated API request.
 */
export async function apiFetch(
  endpoint: string,
  options: RequestInit = {}
): Promise<Response> {
  const token = getAuthToken();

  const headers: HeadersInit = {
    ...options.headers,
  };

  // Only set JSON content-type when body isn't FormData
  if (!(options.body instanceof FormData)) {
    (headers as Record<string, string>)['Content-Type'] = 'application/json';
  }

  if (token) {
    (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  }

  return fetch(resolveApiUrl(endpoint), {
    ...options,
    headers,
    credentials: 'include',
  });
}
